import { atom } from "jotai"
import {
  LessonWithCard,
  PlayingState,
  PlaylistInfoState,
} from "../playlists/types"

export const playingStateAtom = atom<PlayingState>({ type: "NONE" })

export const playlistInfoAtom = atom(
  (get) => {
    const playingState = get(playingStateAtom)
    if (playingState.type !== "VISIBLE") return null
    return playingState.playlistInfo
  },
  (get, set, playlistInfo: PlaylistInfoState) => {
    const currentPlayingState = get(playingStateAtom)
    if (currentPlayingState?.type !== "NONE") {
      set(playingStateAtom, {
        ...currentPlayingState,
        playlistInfo: playlistInfo,
      })
    }
  }
)

export const isPlayingAtom = atom(
  (get) => {
    const playingState = get(playingStateAtom)
    if (playingState.type !== "NONE") {
      return playingState.isPlaying || false
    }
  },
  (get, set, playingState: boolean) => {
    const currentPlayingState = get(playingStateAtom)
    if (currentPlayingState?.type !== "NONE") {
      set(playingStateAtom, { ...currentPlayingState, isPlaying: playingState })
    }
  }
)

export const isMutedAtom = atom(
  (get) => {
    const playingState = get(playingStateAtom)
    return playingState?.type !== "NONE" ? playingState.isMuted : false
  },
  (get, set, isMuted: boolean) => {
    const currentPlayingState = get(playingStateAtom)
    if (currentPlayingState?.type !== "NONE") {
      set(playingStateAtom, { ...currentPlayingState, isMuted: isMuted })
    }
  }
)

export const isLoadingAtom = atom(
  (get) => {
    const playingState = get(playingStateAtom)
    return playingState?.type !== "NONE" ? playingState.isLoading : false
  },
  (get, set, isLoading: boolean) => {
    const currentPlayingState = get(playingStateAtom)
    if (currentPlayingState?.type !== "NONE") {
      set(playingStateAtom, { ...currentPlayingState, isLoading: isLoading })
    }
  }
)

export const audioElementRefAtom = atom<HTMLAudioElement | null>(null)
// export const audioVolumeAtom = atom<number>(0.5)
export const audioCurrentTimeAtom = atom<number>(0)
export const audioDurationAtom = atom<number>(0)
export const audioLoopAtom = atom<boolean>(false)
export const audioShuffleAtom = atom<boolean>(false)

export const indexAtom = atom((get) => {
  const playingState = get(playingStateAtom)
  return playingState.type === "VISIBLE" ? playingState.index : -1
})

export const playlistAtom = atom(
  (get) => {
    const playingState = get(playingStateAtom)
    return playingState.type === "VISIBLE" ? playingState.list : null
  },
  (get, set, list: { lesson: LessonWithCard }[]) => {
    const currentPlayingState = get(playingStateAtom)
    if (currentPlayingState?.type !== "NONE") {
      set(playingStateAtom, { ...currentPlayingState, list, index: 0 })
    }
  }
)

export const currentPlayingItemAtom = atom((get) => {
  const lessons = get(playlistAtom)
  const index = get(indexAtom)
  return lessons ? lessons[index] : null
})

export const nextTrackAtom = atom((get) => {
  const index = get(indexAtom)
  if (index === -1) return null
  const lessons = get(playlistAtom)
  if (!lessons) return null
  const nextIndex = index + 1
  if (nextIndex >= lessons.length) return null
  return nextIndex
})

export const previousTrackAtom = atom((get) => {
  const index = get(indexAtom)
  if (index === -1) return null
  const lessons = get(playlistAtom)
  if (!lessons) return null
  const previousIndex = index - 1
  if (previousIndex < 0) return null
  return previousIndex
})
